module.exports = __webpack_public_path__ + "50f1315bdea3da718ab1dda00646141a.png";